/* ============================================================
   TSURATSURA Corporate - Scripts
   ============================================================ */
(function() {
  'use strict';

  /* --- Spotlightテーマ html font-size リセット（:has()非対応ブラウザ用） --- */
  if (document.body.classList.contains('ts-corp-body')) {
    document.documentElement.style.fontSize = '100%';
  }

  /* --- Scroll Reveal --- */
  if (typeof IntersectionObserver !== 'undefined') {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);

          /* Counter Animation */
          var counters = entry.target.querySelectorAll('[data-target]');
          counters.forEach(function(el) {
            var target = parseInt(el.getAttribute('data-target'), 10);
            var current = 0;
            var unit = el.querySelector('span');
            var interval = setInterval(function() {
              current++;
              if (unit) {
                el.childNodes[0].textContent = Math.min(current, target);
              } else {
                el.textContent = Math.min(current, target);
              }
              if (current >= target) clearInterval(interval);
            }, 80);
          });
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.ts-rv, .ts-rv-s').forEach(function(el) {
      revealObserver.observe(el);
    });
  } else {
    document.querySelectorAll('.ts-rv, .ts-rv-s').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  /* --- Sticky Nav --- */
  var nav = document.getElementById('ts-corp-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.classList.toggle('is-scrolled', window.scrollY > 80);
    }, { passive: true });
  }

  /* --- Mobile Menu --- */
  var mobileToggle = document.getElementById('ts-corp-mobile-toggle');
  var mobileNav = document.getElementById('ts-corp-nav-links');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      var open = mobileNav.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', open);
    });
  }

  /* --- Scroll Depth GA4 --- */
  if (typeof gtag === 'function') {
    var depthMarks = [25, 50, 75, 100];
    var depthFired = {};
    window.addEventListener('scroll', function() {
      var scrollPct = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
      depthMarks.forEach(function(mark) {
        if (scrollPct >= mark && !depthFired[mark]) {
          depthFired[mark] = true;
          gtag('event', 'scroll_depth', { depth: mark, page_path: window.location.pathname });
        }
      });
    }, { passive: true });
  }
})();
